import { Card } from "@/components/kit";
import { formatGal } from "@/lib/tank";
import { ftIn } from "@/lib/measure";

const Match = ({ x, best, onUse, t, i }) => (
  <div className={`measure-match ${best ? "best" : ""}`} data-testid={`measure-match-${i}`}>
    <div>
      <b>{`${formatGal(x.capacity)} gal`}</b> · {`${x.diameter}"`} · {t(x.ends === "dome" ? "FG" : "steel")}
      <div className="card-sub">{t("about {l} long", { l: ftIn(x.lengthIn) })}{!x.inRange ? ` · ${t("outside the width range")}` : ""}</div>
    </div>
    <button type="button" className={best ? "primary-btn" : "ghost-btn"} onClick={() => onUse(x)} data-testid={`measure-use-${i}`}>{t("Use this tank")}</button>
  </div>
);

export const MeasureResult = ({ r, onUse, t }) => {
  if (!r) return <Card testID="measure-empty"><div className="card-sub">{t("Enter the stick reading at the bottom. It must be at least 30 in more than the fill pipe height.")}</div></Card>;
  return (
    <Card testID="measure-result">
      <div className="label">{t("Estimated width")}</div>
      <div className="measure-big" data-testid="measure-width">{`${r.width.toFixed(1)}"`}</div>
      <div className="card-sub" data-testid="measure-range">{t("Could be {a}–{b} wide, depending on the real fill pipe height.", { a: `${Math.round(r.range[0])}"`, b: `${Math.round(r.range[1])}"` })}</div>
      {r.rawCapacity && <div className="measure-raw" data-testid="measure-raw-capacity">{t("Your measurements hold about {g} gal ({l} long).", { g: formatGal(r.rawCapacity), l: ftIn(r.lengthIn) })}</div>}
      <div className="label">{t("Closest standard tanks")}</div>
      {r.matches.map((x, i) => <Match key={`${x.capacity}-${x.diameter}`} x={x} i={i} best={i === 0} onUse={onUse} t={t} />)}
      <p className="scan-caution">{t("This is an estimate. Check it against the console or the store's chart before you rely on it, and never drop more than the room you're sure of.")}</p>
    </Card>
  );
};
